import React from "react";

function States({ onStateSelect }) {
    return (
        <>
            {/* no userd */}
        </>
    );
}

export default States;
